import { TFunction } from "i18next";

import { TeamRoleEnum } from "graphql/types";

export const getTeamRoleLabel = (role: TeamRoleEnum, t: TFunction): string => {
  switch (role) {
    case TeamRoleEnum.Owner:
      return t("common:teamRole.owner.label", "Owner");

    case TeamRoleEnum.Admin:
      return t("common:teamRole.admin.label", "Admin");

    case TeamRoleEnum.Member:
      return t("common:teamRole.member.label", "Member");

    default:
      return ((_role: never) => "")(role);
  }
};

export const getTeamRoleDescription = (
  role: TeamRoleEnum,
  t: TFunction
): string => {
  switch (role) {
    case TeamRoleEnum.Owner:
      return t("common:teamRole.owner.description", "Owner of the account");

    case TeamRoleEnum.Admin:
      return t(
        "common:teamRole.admin.description",
        "Can manage members and departments"
      );

    case TeamRoleEnum.Member:
      return t(
        "common:teamRole.member.description",
        "Can manage candidates in their own departments"
      );

    default:
      return ((_role: never) => "")(role);
  }
};
